module.exports = __webpack_public_path__ + "img/process-icon-6.239abb45.svg";